import { FILTRO_REQUERIMIENTOSCOMPRASPENDIENTES, LISTAR_REQUERIMIENTOSCOMPRAPENDIENTES_FILTRADO } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case FILTRO_REQUERIMIENTOSCOMPRASPENDIENTES:
      return {
        ...state,
        filtrosRequerimientosPendientes: action.payload,
      };
    case LISTAR_REQUERIMIENTOSCOMPRAPENDIENTES_FILTRADO:
      return {
        ...state,
        requerimientosPendientesFiltradas: action.payload,
      };
    default:
      return state;
  }
};
